import React from 'react';

const FlattenAtMarketCloseDocs = (
  <p>
    This will flatten the existing Trade Plan near the regular equity market
    close, around 3:59 pm Eastern. Keep this on only when that close matters
    for the instrument or strategy, such as equity options that stop trading
    outside regular hours.
  </p>
);
export default FlattenAtMarketCloseDocs;
